import React, {Component} from 'react';
import Select from "react-select";
import {capitalize} from "@assets/js/functions/helpers";

import '@assets/sass/components/form/_location-select.scss';

export const DEFAULT_LOCATIONS = [
    {
        value: "Świnoujście, Polska",
        label: "Świnoujście, Polska"
    },
    {
        value: "Międzyzdroje, Polska",
        label: "Międzyzdroje, Polska"
    },
    {
        value: "Kołobrzeg, Polska",
        label: "Kołobrzeg, Polska"
    },
    {
        value: 'Dźwirzyno, Polska',
        label: 'Dźwirzyno, Polska'
    },
    {
        value: "Grzybowo, Polska",
        label: "Grzybowo, Polska"
    },
    {
        value: "Ustronie Morskie & Sianożęty, Polska",
        label: "Ustronie Morskie & Sianożęty, Polska"
    },
    {
        value: "Mielno & Gąski, Polska",
        label: "Mielno & Gąski, Polska"
    },
    {
        value: "Sopot & Gdynia, Polska",
        label: "Sopot & Gdynia, Polska"
    },
    {
        value: "Szklarska Poręba, Polska",
        label: "Szklarska Poręba, Polska"
    },
    {
        value: "Karpacz, Polska",
        label: "Karpacz, Polska"
    },
    {
        value: "Czarna Góra - Stronie Śląskie, Polska",
        label: "Czarna Góra - Stronie Śląskie, Polska"
    },
    {
        value: "Polanica-Zdrój, Polska",
        label: "Polanica-Zdrój, Polska"
    },
    {
        value: "Duszniki-Zdrój & Zieleniec, Polska",
        label: "Duszniki-Zdrój & Zieleniec, Polska"
    },
    {
        value: "Świeradów-Zdrój, Polska",
        label: "Świeradów-Zdrój, Polska",
    },
    {
        value: "Zakopane, Polska",
        label: "Zakopane, Polska",
    },
    {
        value: "Wisła, Polska",
        label: "Wisła, Polska",
    },
    {
        value: "Szczyrk, Polska",
        label: "Szczyrk, Polska",
    },
    {
        value: "Ustroń, Polska",
        label: "Ustroń, Polska",
    },
    {
        value: "Kłodzko, Polska",
        label: "Kłodzko, Polska",
    },
    {
        value: "Pobierowo, Polska",
        label: "Pobierowo, Polska",
    },
    {
        value: "Gdańsk, Polska",
        label: "Gdańsk, Polska",
    },
    {
        value: "Ostróda, Polska",
        label: "Ostróda, Polska",
    },
    {
        value: "Bystrzyca Kłodzka, Polska",
        label: "Bystrzyca Kłodzka, Polska",
    },
    {
        value: "Kamienna Góra k. Karpacza, Polska",
        label: "Kamienna Góra k. Karpacza, Polska",
    },
    {
        value: "Łomnica k. Karpacza, Polska",
        label: "Łomnica k. Karpacza, Polska",
    },
    {
        value: "Jastrzębia Góra, Polska",
        label: "Jastrzębia Góra, Polska",
    },
    {
        value: "Zarzecze k. Żywca, Polska",
        label: "Zarzecze k. Żywca, Polska",
    },
    {
        value: "Darłowo, Polska",
        label: "Darłowo, Polska",
    },
    {
        value: "Jelenia Góra, Polska",
        label: "Jelenia Góra, Polska",
    },
    {
        value: "Rogowo, Polska",
        label: "Rogowo, Polska",
    },
    {
        value: "Dziwnów, Polska",
        label: "Dziwnów, Polska",
    },
    {
        value: "Mielenko & Sarbinowo, Polska",
        label: "Mielenko & Sarbinowo, Polska",
    },
    {
        value: "Czarny Dunajec, Polska",
        label: "Czarny Dunajec, Polska",
    },
    {
        value: "Krynica-Zdrój, Polska",
        label: "Krynica-Zdrój, Polska",
    },
    {
        value: "Sosnówka k. Karpacza, Polska",
        label: "Sosnówka k. Karpacza, Polska",
    },
    {
        value: "Sękowa k. Nowego Sącz, Polska",
        label: "Sękowa k. Nowego Sącz, Polska",
    },
    {
        value: "Wysowa-Zdrój, Polska",
        label: "Wysowa-Zdrój, Polska",
    },
    {
        value: "Średnia Wieś, Polska",
        label: "Średnia Wieś, Polska",
    },
    {
        value: "Iława, Polska",
        label: "Iława, Polska",
    },
    {
        value: "Bułgaria",
        label: "Bułgaria",
    },
];

export default class LocationInput extends Component {
    constructor(props) {
        super(props);
        this.state = {
            options: DEFAULT_LOCATIONS,
            value: '',
            placeholderValue: ''
        };
    }

    componentDidMount() {
        const {initialValue} = this.props;

        this.setPlaceholder(initialValue);
    }

    setPlaceholder = (placeholderChanged) => {
        let placeholderValue = this.props.translations['where-do-you-want-to-go'];

        if (placeholderChanged !== '') {
            placeholderValue = placeholderChanged.charAt(0).toUpperCase() + placeholderChanged.slice(1)
        }

        this.setState({placeholderValue})
    }

    handleChange = value => {
        const placeholderInitial = this.props.translations['where-do-you-want-to-go'];
        const {placeholderValue} = this.state;

        this.setState({
            value: value
        });

        this.props.onChangeFilter({
            location: value ? value['value'] : ''
        });

        if (placeholderValue !== placeholderInitial) {
            this.setState({
                placeholderValue: placeholderInitial
            })
        }
    };

    handleInputChange = value => {
        if (!value || value === '') {
            this.setState({
                options: DEFAULT_LOCATIONS
            });
            return;
        }
        fetch(`/api/autocomplete?location=${value}`)
            .then(response => {
                return response.json();
            })
            .then((json) => {
                let options = [];
                json.forEach(prediction => {
                    options.push({
                        label: prediction['location'],
                        value: prediction['location'],
                    })
                });
                this.setState({
                    options: options
                })
            });
    }

    render() {
        const {value, options, placeholderValue} = this.state;
        const {translations} = this.props;

        return (
            <div className="search-filters__form-control location-select-container">
                <label htmlFor="location" className="filter-title">{translations['place']}</label>
                <Select
                    // onInputChange={this.handleInputChange}
                     onChange={this.handleChange}
                    isClearable={false}
                    value={value}
                    options={options}
                    className={'form-controller--select-location'}
                    classNamePrefix="form-controller--select-location"
                    placeholder={placeholderValue}
                />
                {/*form-control form-control__select*/}
            </div>
        );
    };
};
